class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // SARIA: load "Complete the Look" (data-url) and "You May Also Like" (data-url-related)
    const urls = [this.dataset.url, this.dataset.urlRelated].filter(Boolean);

    Promise.all(
      urls.map((url) =>
        fetch(url)
          .then((response) => response.text())
          .catch(() => '')
      )
    )
      .then((texts) => {
        const seen = new Set();
        let output = '';

        texts.forEach((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('cart-recommendations');
          if (!recommendations) return;

          const groups = recommendations.querySelectorAll('[data-saria-group]');
          if (!groups.length) {
            if (!recommendations.querySelector('.saria-cart-placeholder') && recommendations.innerHTML.trim().length) {
              output += recommendations.innerHTML;
            }
            return;
          }

          // SARIA: no duplicates across both lists
          groups.forEach((group) => {
            group.querySelectorAll('li[data-saria-key]').forEach((item) => {
              const key = item.dataset.sariaKey;
              if (seen.has(key)) {
                item.remove();
              } else {
                seen.add(key);
              }
            });
            if (group.querySelector('li')) output += group.outerHTML;
          });
        });

        if (output.trim().length) {
          this.innerHTML = output;
        } else if (this.querySelector('.saria-cart-placeholder')) {
          this.style.display = 'none';
        }

        // Scroll the mini-cart drawer to the top after recommendations load
        const miniCartMain = document.querySelector('#main-cart-items');
        if (miniCartMain) {
          miniCartMain.scrollTop -= miniCartMain.scrollHeight;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
